import * as companySession from "@/components/new/CompanySession/redux";
import * as companyUiInteractions from "@/components/new/CompanyUiInteractions/redux";
import * as orderAssignUserViaContextMenu from "@/components/new/OrderAssignUserViaContextMenu/redux";
import * as paymentStatus from "@/components/new/PaymentStatus/redux";
import * as purchaseProductsModal from "@/components/new/PurchaseProductsModal/redux";
import * as salesOrderInvoicingAttachments from "@/components/new/SalesOrderInvoicing/CreateDocumentModal/AttachmentsCard/redux";
import * as salesOrderInvoicingEmailCard from "@/components/new/SalesOrderInvoicing/CreateDocumentModal/EmailInvoiceCard/redux";
import * as salesOrderInvoicingCreate from "@/components/new/SalesOrderInvoicing/CreateInvoiceModal/redux";
import * as salesOrderInvoicingCreatePartial from "@/components/new/SalesOrderInvoicing/CreatePartialInvoiceModal/redux";
import * as salesOrderInvoicingCreateProforma from "@/components/new/SalesOrderInvoicing/CreateProformaInvoiceModal/redux";
import * as salesOrderInvoicingFtue from "@/components/new/SalesOrderInvoicing/FirstTimeUserExperienceModal/redux";
import * as stripeIntegrationTile from "@/components/new/StripeIntegrationTile/redux";
import * as userUiInteractions from "@/components/new/UserUiInteractions/redux";
import * as userSession from "@/components/UserSession/redux";

const newRootReducers = {
  [orderAssignUserViaContextMenu.MODULE]: orderAssignUserViaContextMenu.reducer,
  [paymentStatus.MODULE]: paymentStatus.reducer,
  [userSession.MODULE]: userSession.reducer,
  [purchaseProductsModal.MODULE]: purchaseProductsModal.reducer,
  [companySession.MODULE]: companySession.reducer,
  [companyUiInteractions.MODULE]: companyUiInteractions.reducer,
  [userUiInteractions.MODULE]: userUiInteractions.reducer,
  [stripeIntegrationTile.MODULE]: stripeIntegrationTile.reducer,
  [salesOrderInvoicingFtue.MODULE]: salesOrderInvoicingFtue.reducer,
  [salesOrderInvoicingCreate.MODULE]: salesOrderInvoicingCreate.reducer,
  [salesOrderInvoicingCreateProforma.MODULE]: salesOrderInvoicingCreateProforma.reducer,
  [salesOrderInvoicingCreatePartial.MODULE]: salesOrderInvoicingCreatePartial.reducer,
  [salesOrderInvoicingAttachments.MODULE]: salesOrderInvoicingAttachments.reducer,
  [salesOrderInvoicingEmailCard.MODULE]: salesOrderInvoicingEmailCard.reducer,
};

export default newRootReducers;
